import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/IdentityPicker/IdentityPickerUsage.mdx";

import Examples from "../../Docs/Components/IdentityPicker/IdentityPickerExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Identity picker"
            description="An identity picker component is used to select one or more people or groups from a list."
            apiSources={["azure-devops-ui/Components/IdentityPicker/IdentityPicker.Props.d.ts", "azure-devops-ui/Components/IdentityPickerDropdown/IdentityPickerDropdown.Props.d.ts", "azure-devops-ui/Components/IdentityPickerDropdown/SharedIdentityPicker.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;